
import React                 from 'react';
import { observer, inject  } from 'mobx-react';

import { Menu              } from './commun/Menu';
import { BandeauSmartphone } from './commun/BandeauSmartphone';

/* *********************************************************************************** */
/* **********                                                               ********** */
/* **********                        ListeTomeSmartphone                    ********** */
/* **********                                                               ********** */
/* *********************************************************************************** */

export const ListeTomeSmartphone = inject(['store'])(observer(class ListeTomeSmartphone extends React.Component {

    /* ------------ */
    /* Constructeur */
    /* ------------ */

    constructor(props){
        super(props);

        this.state = { spoil2 : false, spoil3 : false }

        this.afficherSpoil = this.afficherSpoil.bind(this);
    }        

    /* ----------------------------- */
    /* Affichage des données cachées */
    /* ----------------------------- */

    afficherSpoil (noSpoil=0)
    {
        switch (Number(noSpoil))
        {
            case  2 : this.setState ({ spoil2 : true }); break;
            case  3 : this.setState ({ spoil3 : true }); break;
            default :                                    break;
        }
        
    }

    /* ---------------------- */
    /* Affichage du composant */
    /* ---------------------- */

    render() {

        /* ------------------------------ */
        /* Définition des CSS d'affichage */
        /* ------------------------------ */

        const styleBloc = {
            width        : (window.innerWidth - 20) + "px",
            display      : "block",
            marginTop    : "20px",
            marginBottom : "10px"
        };

        const styleSpoil = {
            backgroundColor : "#AC8F63", 
            color           : "#AC8F63" 
        };

        /* ----------------------------------------- */
        /* Définition de l'onglet du menu à afficher */
        /* ----------------------------------------- */

        this.props.store.definirSelectionOnglet ("listetome");

        /* ------------------------------- */
        /* Définition du titre de l'onglet */
        /* ------------------------------- */

        document.title = "Liste des tomes - La geste d'Aros";

        /* -------------------------------- */
        /* Formatage des données à afficher */
        /* -------------------------------- */

        const znSpoil2 = this.state.spoil2 ? null : styleSpoil;
        const znSpoil3 = this.state.spoil3 ? null : styleSpoil;

        /* ------------------- */
        /* Renvoi du composant */
        /* ------------------- */

        return (

            <div id='divListeTomeSmartphone' style={{textAlign:'center'}}> 

                <BandeauSmartphone />

                <Menu menu = {this.props.store.menu} />

                <div style={styleBloc}>  

                        <p className="Parution" style={{marginBottom:'15px'}}>
                            Déjà paru :
                        </p>

                        <p className="TitreTome" style={{marginTop:'15px',marginBottom:'10px'}}>
                            1. La sorcière
                        </p>

                        <div className="tome1"></div>

                        <p className="Recit" style={{marginTop:'20px'}}>
                            Dans un monde médiéval baigné par la magie et peuplé de créatures fantastiques, un noble seigneur a recours aux services d’une sorcière pour affaiblir l’un de ses rivaux. En apparence anodine, cette transaction aura des répercussions majeures sur l’avenir du royaume d’Aros, bouleversant à jamais la vie de ceux qui deviendront ses protecteurs. 
                        </p>

                        <div style={{display:"flex",flexDirection: "row", justifyContent: 'space-evenly', width:'100%', marginTop:"20px"}}>

                            <div style={{display:"inline-block"}}>
                                <a href='https://www.amazon.fr/geste-dAros-1-sorci%C3%A8re/dp/2957286203' target='_blank' rel="noopener noreferrer">
                                <div className="amazon"></div>
                                </a>  
                                <div className="Recit" style={{marginTop:'10px'}}>
                                <center><b>Livre broché</b><br />25 €</center>
                                </div>
                            </div>

                            <div style={{display:"inline-block"}}>
                            <a href='https://www.amazon.fr/geste-dAros-1-sorci%C3%A8re-ebook/dp/B088P7DD3S/ref=tmm_kin_swatch_0?_encoding=UTF8&qid=&sr=' target='_blank' rel="noopener noreferrer">
                                <div className="amazon"></div>
                                </a>   
                                <div className="Recit" style={{marginTop:'10px'}}>
                                <center>Version <b>Kindle</b><br />4 €</center>
                                </div>
                            </div>

                        </div>

                        <div style={{display:"flex",flexDirection: "row", justifyContent: 'space-evenly', width:'100%', marginTop:"10px"}}>

                            <div style={{display:"inline-block"}}>
                                <a href='https://www.kobo.com/fr/fr/ebook/la-sorciere-25' target='_blank' rel="noopener noreferrer">
                                    <div className="kobo"></div>
                                </a>   
                                <div className="Recit" style={{marginTop:'10px'}}>
                                <center>Version <b>Kobo</b><br />4 €</center>
                                </div>
                            </div>

                            <div style={{display:"inline-block"}}>
                                <a href="/aros/epub/La geste d'Aros - 1. La sorcière.epub" download>
                                    <div className="epub"></div>
                                </a>   
                                <div className="Recit" style={{marginTop:'10px'}}>
                                <center>Version <b>epub</b><br /><i>gratuit</i></center>
                                </div>
                            </div>

                        </div>  

                        <p className="TitreTome" style={{marginTop:'15px',marginBottom:'10px'}}>
                            2. Guilaine
                        </p>

                        <div className="tome2"></div>

                        <div className="Recit" style={{marginTop:'20px'}}>
                            Dix ans ont passé depuis que&nbsp;
                            <span style={znSpoil2} onClick={()=>this.afficherSpoil(2)}>la baronne Roxane de Marena est devenue reine d'Aros</span>
                            . Le royaume est en paix, la noblesse maîtrisée, et malgré quelques rares incursions, les créatures du monde sauvage restent dans leurs territoires. Tout semble donc aller pour le mieux. Mais les nuages s’amoncellent.  Et dans la tourmente qui approche, une jeune femme chevalier et ses compagnons s’avèreront être les seuls  à même de protéger le royaume.
                        </div>

                        <div style={{display:"flex",flexDirection: "row", justifyContent: 'space-evenly', width:'100%', marginTop:"20px"}}>

                            <div style={{display:"inline-block"}}>
                                <a href='https://www.amazon.fr/geste-dAros-2-Guilaine/dp/2957286246/ref=tmm_pap_swatch_0?_encoding=UTF8&qid=&sr=' target='_blank' rel="noopener noreferrer">
                                <div className="amazon"></div>
                                </a>  
                                <div className="Recit">
                                <center><b>Livre broché</b><br /><br />25 €</center>
                                </div>
                            </div>

                            <div style={{display:"inline-block"}}>
                            <a href='https://www.amazon.fr/gp/product/B09K4TFYPC?ref_=dbs_m_mng_rwt_calw_tkin_1&storeType=ebooks' target='_blank' rel="noopener noreferrer">
                                <div className="amazon"></div>
                                </a>   
                                <div className="Recit">
                                <center>Version <b>Kindle</b><br /><br />4 €</center>
                                </div>
                            </div>

                        </div>

                        <div style={{display:"flex",flexDirection: "row", justifyContent: 'space-evenly', width:'100%', marginTop:"10px"}}>

                            <div style={{display:"inline-block"}}>
                                      <a href='https://www.kobo.com/fr/fr/ebook/guilaine' target='_blank' rel="noopener noreferrer">
                                          <div className="kobo"></div>
                                      </a>   
                                      <br /><br />
                                      <div className="Recit">
                                        <center>Version <b>Kobo</b><br /><br />4 €</center>
                                      </div>
                                  </div>

                        </div>  

                    <p className="Parution" style={{marginBottom:'25px'}}>
                        A paraître :
                    </p>

                    <p className="TitreTome" style={{marginTop:'15px',marginBottom:'10px'}}>
                        3. Vengar
                    </p>

                    <div style={{fontSize:'1.2em',marginBottom:'10px'}}><i>Image provisoire</i></div>

                    <div className="tome3"></div>

                    <div className="Recit" style={{marginTop:'20px'}}>
                            Grâce à l’action de Guilaine de Finaeld et de ses amis,&nbsp;
                            <span style={znSpoil3} onClick={()=>this.afficherSpoil(3)}>le dernier descendant de la lignée légitime des monarques d’Aros est enfin parvenu à monter sur le trône</span>
                            . Mais personne ne se doute que cet heureux dénouement n’a été rendu possible que par les manœuvres aussi discrètes qu’efficaces d’un mystérieux et très puissant Archimage, dont le but ultime reste encore inconnu.                                
                    </div>

                    <br />
                    <br />
                    &nbsp;

                </div>    

            </div>
        )
    } 
  } // Fin de la classe ListeTomeSmartphone
))



// WEBPACK FOOTER //
// ./src/components/ListeTomeSmartphone.js